export default __webpack_public_path__ + "static/media/two-phones.0fc4fc33.webp";